<template>
  <div>
    <Modal v-model="openForm" :title="title" footer-hide fullscreen>
      <report-top
        ><ly-search
          slot="search"
          v-model="searchItem.keyword"
          @search="search"
        ></ly-search>
      </report-top>
      <div id="formTable">
        <div id="formTable">
          <div class="formTableItem">
            <p class="label">时间范围</p>
            <start-end ref="startEnd" timeModel="2,3,0"></start-end>
          </div>
          <div class="formTableItem">
            <Button @click="exportAll" v-if="false" size="small" class="chaxun"
              >导出</Button
            >
            <Button @click="chaxun" type="primary" size="small" class="chaxun"
              >查询</Button
            >
          </div>
        </div>
      </div>

      <Table
        border
        :columns="columns"
        :data="tableData"
        no-data-text="<div class='table-no-data'></div>"
        :height="utils.setTableHeight(250)"
      >
        <template slot-scope="{ row, index }" :slot="'time'">
          {{ utils.time(row.time, "yymmdd") }}
        </template>
        <viewer slot-scope="{ row, index }" :slot="'approveFileList'">
          <img
            v-for="(y, index1) in row.approveFileList"
            :key="index1"
            :src="axios.platConfig.fileUri + y"
            width="24"
            height="24"
            style="margin-right: 4px; cursor: pointer"
          />
        </viewer>
        <viewer slot-scope="{ row, index }" :slot="'handoverFileList'">
          <img
            v-for="(y, index1) in row.handoverFileList"
            :key="index1"
            :src="axios.platConfig.fileUri + y"
            width="24"
            height="24"
            style="margin-right: 4px; cursor: pointer"
          />
        </viewer>
        <template slot-scope="{ row, index }" :slot="'time'">
          {{ utils.time(row.time, "yymmdd") }}
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <Button @click="detail(row)" size="small">详情</Button>
          <Button v-if="false" @click="xunchajilu(row)" size="small"
            >巡查记录</Button
          >
          <Button v-if="false" @click="yanghujilu(row)" size="small"
            >养护记录</Button
          >
        </template>
      </Table>
      <div id="mypage">
        <div>
          <Page
            :current="1"
            :total="total"
            :page-size="searchItem.pageSize"
            :page-size-opts="[10, 50, 100]"
            show-total
            show-elevator
            show-sizer
            @on-change="changePage"
            @on-page-size-change="pageSizeChange"
          ></Page>
        </div>
      </div>
    </Modal>
    <nightRecordList ref="nightRecordList"></nightRecordList>
    <dailyRecordList ref="dailyRecordList"></dailyRecordList>
    <docDetail ref="docDetail"></docDetail>
  </div>
</template>
<script>
import axios from "axios";
import fields from "./fields";
import nightRecordList from "./nightRecordList.vue";
import dailyRecordList from "./dailyRecordList.vue";
import docDetail from "../docDetail.vue"
export default {
  components: { nightRecordList, dailyRecordList,docDetail },
  data() {
    return {
      columns: [],
      tableData: [],
      total: 0,
      searchItem: {
        deviceIdList: [],
        driverIdList: [],
        endTime: 0,
        startTime: 0,
        pageSize: 50,
        pageNumber: 1,
        keyword: "",
      },
      title: "",
      openForm: false,
      openForm123: false,
      serverUrl: "",
      item: {
        confirmType: 1, //1-部门领导，2-作业负责人
        confirmer: "",
        id: "",
      },
      ruleValidate: {
        confirmer: { required: true, message: "必填" },
      },
    };
  },
  methods: {
    reach(v) {
      this.reset();
      this.formId=v.id;
      var that = this;
      this.columns = JSON.parse(JSON.stringify(fields[v.field]));
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].key = this.columns[i].key1;
        if (this.columns[i].show == "yymmdd") {
          this.columns[i].slot = "time";
          /* this.columns[i].render = function (h, data) {
            return h("div", that.utils.time(data.row.time, "yymmdd"));
          }; */
        } else if (this.columns[i].key == "handoverFileList") {
          this.columns[i].slot = "handoverFileList";
        } else if (this.columns[i].key == "approveFileList") {
          this.columns[i].slot = "approveFileList";
        }
      }
      this.columns.splice(
        0,
        0,
        {
          type: "index",
        },
        {
          title: "养护单号",
          key: "no",
        }
      );
      this.columns.push({
        title: "操作",
        slot: "action",
      });
      this.openForm = true;
      this.title = v.name;
      this.serverUrl = v.serverUrl;
      this.chaxun();
    },
    getList() {
      this.tableData = [];
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: this.serverUrl + "/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          this.total = res.data.data.total;
          var data = res.data.data.dataList;
          this.tableData = data;
        }
      });
    },
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          axios({
            method: "post",
            url: this.serverUrl + "/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    exportAll() {
      var params = [
        {
          name: "deviceIdList",
          value: this.searchItem.deviceIdList,
        },
        {
          name: "driverIdList",
          value: this.searchItem.driverIdList,
        },
        {
          name: "startTime",
          value: this.searchItem.startTime,
        },
        {
          name: "endTime",
          value: this.searchItem.endTime,
        },
      ];
      this.utils.exportData(axios.report + "/driving/export/daily", params);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    chaxun() {
      this.searchItem.startTime = this.$refs.startEnd.getTimeObj().start;
      this.searchItem.endTime = this.$refs.startEnd.getTimeObj().end;
      this.getList();
    },
    search() {
      this.reset();
      this.getList();
    },
    reset() {
      this.tableData = [];
    },
    xunchajilu(row) {
      var obj = {
        key: "",
        name: row.name,
        docId: row.id,
      };
      this.$refs.nightRecordList.reach(obj);
    },
    yanghujilu(row) {
      var obj = {
        key: "",
        name: row.name,
        docId: row.id,
      };
      this.$refs.dailyRecordList.reach(obj);
    },
    detail(row){
      var obj={
        formId:this.formId,
        docId:row.id
      };
      this.$refs.docDetail.reach(obj);
    }
  },
  mounted() {
    //this.chaxun();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/yhgl/forms/formList.vue